module.exports = __webpack_public_path__ + "static/media/dollar.7f4480af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/dollar.svg
// module id = 2996
// module chunks = 0